<template>
    <div class="product-map__filter" :class="{ 'product-map__filter--visible-options': open }">
        <div class="product-map__filter-drop-down hidden md:flex" @click="open = !open">
            <span class="product-map__filter-selected h5 text-grey-600">
                {{ activeCategory ? activeCategory.title : 'Filter by type' }}
            </span>
            <span class="product-map__filter-arrow"></span>
        </div>

        <button
            class="productMap-filterBtn relative js-toggle bg-white rounded-full w-16 h-16 inline-flex justify-center items-center focus:outline-none md:hidden"
            data-target="html"
            data-target-class="productMap-filter-active"
            @click="open = !open"
        >
            <div
                class="productMap-filterBtn-count bg-black rounded-full text-white text-xs w-5 h-5 border border-white absolute right-0 top-0 flex justify-center items-center"
                :class="{ hidden: activeCategory === null, block: activeCategory !== null }"
            >
                <span class="leading-none">1</span>
            </div>

            <!-- prettier-ignore -->
            <svg class="productMap-filter-open" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.826 9.29h.75a.75.75 0 0 0-.176-.483l-.574.483Zm-5.59-6.646.575-.483-.574.483Zm15.236 0-.574-.483.574.483Zm-5.646 6.713-.574-.483a.75.75 0 0 0-.176.483h.75Zm0 4.671.45.6a.75.75 0 0 0 .3-.6h-.75Zm-4 3h-.75a.75.75 0 0 0 1.2.6l-.45-.6ZM7.4 8.807 1.81 2.16l-1.147.965 5.589 6.646L7.4 8.807ZM1.81 2.16a.25.25 0 0 1 .192-.411V.25C.514.25-.295 1.988.662 3.126l1.149-.965Zm.192-.411h13.705V.25H2.002v1.5Zm13.705 0a.25.25 0 0 1 .19.41l1.149.966c.957-1.138.148-2.876-1.34-2.876v1.5Zm.19.41-5.645 6.714 1.148.966 5.646-6.714-1.148-.965Zm-5.821 7.197v4.671h1.5V9.357h-1.5Zm.3 4.071-4 3 .9 1.2 4-3-.9-1.2Zm-2.8 3.6V9.29h-1.5v7.738h1.5Z" fill="#1F2B3F"/></svg>
            <!-- prettier-ignore -->
            <svg class="productMap-filter-close hidden" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9229 12.9234L5.07612 5.07661" stroke="#1F2B3F" stroke-linecap="square"/><path d="M12.9234 5.07616L5.07661 12.9229" stroke="#1F2B3F" stroke-linecap="square"/></svg>
        </button>

        <ul class="product-map__tabs">
            <li
                class="product-map__tab product-map__tab--all"
                :class="{ active: activeCategory === null }"
                @click.prevent="selectCategory(null)"
            >
                ALL
            </li>
            <li
                v-for="category in categories"
                :key="category.slug"
                class="product-map__tab"
                :class="{
                    [`product-map__tab--${category.slug}`]: true,
                    active: activeCategory === category
                }"
                @click.prevent="selectCategory(category)"
            >
                {{ category.title }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        categories: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            open: false,
            activeCategory: null
        };
    },

    methods: {
        selectCategory(category) {
            this.activeCategory = category;
            this.close();
            this.$emit('change', category);
        },

        close() {
            this.open = false;
        }
    }
};
</script>
